/**
 * @author      hank.chen@zumper.com (Hank Chen)
 * @copyright   Copyright (c) 2022, Zumper
 * @description BBB Logo
 */

import React from 'react'
import bbbFile from '../../img/icons/bbb.png'

export const BBB = () => {
  return (
    <img
      alt="BBB Accredited Business"
      height="45"
      id="BBB_Image"
      loading="lazy"
      src={bbbFile}
      width="65"
    />
  )
}
